import { z } from "zod";

export default {
  params: z.object({
    uid: z.string(),
  }),
  response: z.void(),
};
